import { EVENT_PRIVATE_DESCRIPTION_TEXT, EVENT_PUBLIC_DESCRIPTION_TEXT, EVENT_TITLE_FOR_PASSPORT_TEXT } from '../../../../../../constants/common-labels.constants';
import { FormVmItemConfigType } from '../../../../../../infrastructure/form-viewmodel-controller';
import { buildConfigList } from '../../../../../../infrastructure/utils/form-config.utils';
import { trimSpacesLeft } from '../../../../../../modules/formatters';
import { plainText } from '../../../../../../modules/validators';

export enum EditPassportTitleFieldKey {
    TITLE = 'eventTitleForPassport',
    PUBLIC_DESCRIPTION = 'eventPublicDescription',
    PRIVATE_DESCRIPTION = 'eventPrivateDescription',
}

export const EDIT_PASSPORT_TITLE_FORM_CONFIG = {
    [EditPassportTitleFieldKey.TITLE]: {
        labelDescriptor: EVENT_TITLE_FOR_PASSPORT_TEXT,
        defaultValue: '',
        validators: [plainText.maxLength.short],
        formatters: [trimSpacesLeft]
    },
    [EditPassportTitleFieldKey.PUBLIC_DESCRIPTION]: {
        labelDescriptor: EVENT_PUBLIC_DESCRIPTION_TEXT,
        defaultValue: '',
        validators: [plainText.maxLength.long],
        formatters: []
    },
    [EditPassportTitleFieldKey.PRIVATE_DESCRIPTION]: {
        labelDescriptor: EVENT_PRIVATE_DESCRIPTION_TEXT,
        defaultValue: '',
        validators: [plainText.maxLength.long],
        formatters: []
    },
};

export const editPassportTitleConfigList: FormVmItemConfigType[] = buildConfigList(EDIT_PASSPORT_TITLE_FORM_CONFIG);
